import { DateTime } from 'luxon';

import { ReportingTimezone } from '@willow/types-iso';

/**
 * loan.configuration.firstDueDate
 */
export const getPaymentDueDay = (firstDueDate: Date, timezone: ReportingTimezone = 'UTC'): number =>
  DateTime.fromJSDate(firstDueDate, { zone: timezone }).day;

export const doesDateMatchPaymentDueDay = (date: Date, firstDueDate: Date): boolean => {
  const paymentDueDay = getPaymentDueDay(firstDueDate);
  return DateTime.fromJSDate(date).day === paymentDueDay;
};
